import { useTranslation } from "react-i18next";
import { useState, useEffect, useRef } from "react";
import {
  getAggregatedData,
  getAggregatedDataWrapper,
  onFilterModelChange,
  renderGrid,
  aggregatedAdministrativeTableColumns,
} from "./AgroAnalyticsUtils";
import i18n from "i18next";

const aggregatedCommuneTableColumns = () => [
  {
    field: "CodiceIstat",
    headerName: i18n.t("cityCode"),
    width: 80,
  },

  {
    field: "Comune",
    headerName: i18n.t("city"),
    width: 100,
  },

  {
    field: "Provincia",
    headerName: i18n.t("state"),
    width: 20,
  },

  ...aggregatedAdministrativeTableColumns(),
];

export const AgroCommuneGrid = ({ filterModel, wantedReferenceDateProp, setSelectedComuneIstatSetter }) => {
  const { t } = useTranslation();

  const [aggregatedCommuneTableState, setAggregatedCommuneTableState] = useState({
    isLoading: false,
    total: 0,
  });

  const aggregatedCommuneCancelTokenRef = useRef(null);

  const [aggregatedCommuneTableData, setAggregatedCommuneTableData] = useState([]);

  const onRowClickCallback = (params) => {
    const row = params.row;
    setSelectedComuneIstatSetter(row.addressCityCode); // row.id would work same way. It is "999999" comune Istat code.
  };

  useEffect(() => {
    const getAggregatedCommuneData = async () => {
      return await getAggregatedData(
        setAggregatedCommuneTableState,
        setAggregatedCommuneTableData,
        { aggr: "CodiceIstat" },
        filterModel,
        wantedReferenceDateProp,
        aggregatedCommuneCancelTokenRef,
      );
    };

    const getAggregatedCommuneDataWrapper = async () => {
      getAggregatedDataWrapper(aggregatedCommuneCancelTokenRef, getAggregatedCommuneData);
    };

    onFilterModelChange(filterModel, getAggregatedCommuneDataWrapper);
  }, [filterModel, wantedReferenceDateProp]);

  return renderGrid(
    aggregatedCommuneTableColumns(),
    aggregatedCommuneTableData,
    aggregatedCommuneTableState,
    t,
    "Comuni",
    {
      onRowClick: onRowClickCallback,
    },
  );
};
